<template>
  <div id="files" class="content">
    <div class="section-title">
      <div class="row">
        <div class="col-md-6">
          <h3>{{ title }}</h3>
        </div>
        <div class="col-md-6">
          <div class="userLog_bread">
            <span v-if="userLogged">
              {{
                userLogged.comercialName
                  ? userLogged.comercialName
                  : userLogged.name + " " + userLogged.lastName
              }}
            </span>
          </div>
        </div>
      </div>
      <hr />
    </div>
    <div class="filters">
      <div class="row">
        <div class="col-md-4">
          <el-input
            v-model="searchFile"
            placeholder="Buscar"
            clearable
            @change="
              params = { ...params, search: searchFile };
              getFiles();
            "
          >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </div>
        <div class="col-md-8">
          <button
            class="btn btn_gradient"
            style="margin-right: 15px"
            @click="openNewFileModal()"
          >
            Nuevo archivo
          </button>
        </div>
      </div>
    </div>
    <div class="block">
      <el-table :data="files" style="width: 100%">
        <el-table-column
          prop="name"
          label="TÍTULO"
          width="auto"
          min-width="200px"
        >
        </el-table-column>

        <el-table-column fixed="right" label="ACCIONES" width="120">
          <template slot-scope="scope">
            <div
              class="d-inline-flex justify-content-around"
              style="width: 100%"
            >
              <img
                class="pointer"
                src="@/assets/icons/icon_edit.svg"
                @click="openUpdateFileModal(scope.row)"
              />
              <img
                class="pointer"
                src="@/assets/icons/icon_delete.svg"
                @click="
                  selectedFile = scope.row;
                  showDeleteModal = true;
                "
              />
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="row pag">
        <div class="col-md-4 item arrows">
          <div class="d-flex align-items-center pointer" v-if="page > 1">
            <div
              @click="
                page = page > 2 ? page - 1 : 1;
                getFiles();
              "
            >
              <i class="el-icon-arrow-left"></i>
              <span>ANTERIOR</span>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-sm-12 item">
          <el-pagination
            class="text-center"
            @size-change="getFiles()"
            @current-change="getFiles()"
            :current-page.sync="page"
            :page-size="pageSize"
            layout=" prev, pager, next"
            :total="totalFiles"
          >
          </el-pagination>
        </div>
        <div class="col-md-4 item arrows">
          <div
            class="d-flex justify-content-end align-items-center pointer"
            v-if="totalPage > 1"
          >
            <div
              @click="
                page = totalPage > page ? page + 1 : page;
                getFiles();
              "
            >
              <span>SIGUIENTE</span>
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
        </div>
      </div>
      <br />
      <span class="secondary">
        MOSTRANDO {{ page }} - {{ totalPage }} de {{ totalFiles }} RESULTADOS
      </span>
    </div>

    <!-- Modal de eliminación -->
    <Modal
      v-if="showDeleteModal"
      :size="'small'"
      :theme="'pink'"
      @close="
        showDeleteModal = false;
        titleModal = '';
      "
    >
      <template v-slot:content>
        <div class="text-center" id="text">
          <label>
            ¿Está seguro de que desea eliminar el archivo seleccionado?
          </label>
          <button
            class="btn"
            style="margin: 40px 0px"
            @click="
              showDeleteModal = false;
              deleteFile(selectedFile.id);
            "
          >
            Aceptar
          </button>
        </div>
      </template>
    </Modal>

    <!-- Modal de nuevo archivo -->
    <Modal
      v-if="showNewFileModal"
      class="modal-new-file"
      :size="'small'"
      :theme="'pink'"
      @close="closeNewFileModal()"
    >
      <template v-slot:content>
        <div class="text-center" id="text">
          <label>
            Subir nuevo archivo
          </label>

          <el-form
            :model="newFileForm"
            name="newFileForm"
            :rules="newFileRules"
            status-icon
            ref="newFileForm"
          >
            <div class="row">
              <div class="col-sm-12">
                <el-form-item prop="name">
                  <el-input
                    class="input-name"
                    v-model="newFileForm.name"
                    autocomplete="off"
                    placeholder="*Nombre del archivo"
                    @focus="sessionExpired"
                  ></el-input>
                </el-form-item>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-12">
                <el-form-item prop="data">
                  <input
                    type="file"
                    class="input-file"
                    id="file"
                    ref="file"
                    @change="handleFileUpload($event)"
                  />
                </el-form-item>
              </div>
            </div>

            <div class="row modal-item">
              <div class="col-sm-12">
                <button
                  class="btn"
                  style="margin-top: 15px"
                  @click="uploadNewFile()"
                >
                  Aceptar
                </button>
              </div>
            </div>
          </el-form>
        </div>
      </template>
    </Modal>

    <!-- Modal de modificar el nombre -->
    <Modal
      v-if="showUpdateFileModal"
      class="modal-new-file"
      :size="'small'"
      :theme="'pink'"
      @close="closeUpdateFileModal()"
    >
      <template v-slot:content>
        <div class="text-center" id="text">
          <label>
            Editar el archivo
          </label>

          <el-form
            :model="updateFileForm"
            name="updateFileForm"
            :rules="updateRules"
            status-icon
            ref="updateFileForm"
          >
            <div class="row">
              <div class="col-md-12">
                <el-form-item prop="name">
                  <el-input
                    class="input-name"
                    v-model="updateFileForm.name"
                    autocomplete="off"
                    placeholder="*Nombre del archivo"
                    @focus="sessionExpired"
                    :disabled="true"
                  ></el-input>
                </el-form-item>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-12">
                <el-form-item prop="data">
                  <input
                    type="file"
                    class="input-file"
                    id="updateFile"
                    ref="updateFile"
                    @change="handleFileUpload($event, true)"
                  />
                </el-form-item>
              </div>
            </div>

            <div class="row modal-item">
              <div class="col-md-12">
                <button
                  class="btn"
                  style="margin-top: 15px"
                  @click="updateFile()"
                >
                  Aceptar
                </button>
              </div>
            </div>
          </el-form>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
// Components
import { mapState } from "vuex";
import Modal from "@/components/Modal";

import AuthService from "@/services/auth.service";
import FilesService from "@/services/file.service";
import Pagination from "@/model/Pagination";

export default {
  name: "Files",
  components: { Modal },
  data() {
    const fileNameRule = (rule, value, callback) => {
      if (!value || value.length <= 0) {
        callback(new Error("Por favor rellena este campo"));
      } else {
        callback();
      }
    };
    const fileDataRule = (rule, value, callback) => {
      if (this.file == null) {
        callback(new Error("Por favor selecciona un archivo"));
      } else {
        callback();
      }
    };

    return {
      title: "GESTIÓN DE ARCHIVOS DE AYUDA",
      showDeleteModal: false,
      showNewFileModal: false,
      newFileForm: {
        name: "",
        data: null
      },
      newFileRules: {
        name: {
          required: true,
          validator: fileNameRule,
          trigger: "blur"
        },
        data: {
          required: true,
          validator: fileDataRule,
          trigger: "blur"
        }
      },

      showUpdateFileModal: false,
      updateFileForm: {
        id: 0,
        name: "",
        data: null
      },
      updateRules: {
        name: {
          required: true,
          validator: fileNameRule,
          trigger: "blur"
        },
        data: {
          required: true,
          validator: fileDataRule,
          trigger: "blur"
        }
      },

      files: [],
      totalFiles: 0,
      page: 1,
      pageSize: 10,
      totalPage: 0,
      searchFile: "",
      params: {},

      selectedFile: {},
      file: null
    };
  },
  mounted() {
    this.sessionExpired();
    document.querySelector("#app").scrollTop = 0;
    this.getFiles();
  },
  computed: {
    ...mapState({
      userLogged: "user"
    })
  },
  methods: {
    sessionExpired() {
      AuthService.sessionExpired();
    },

    /* Obtiene la lista de archivos */
    getFiles() {
      FilesService.getHelpFiles(
        new Pagination(this.page - 1, this.pageSize, null),
        this.params
      )
        .then(response => {
          this.files = response.data.data.content;
          this.totalFiles = response.data.data.totalElements;
          this.totalPage = response.data.data.totalPages;
        })
        .catch(() => {
          this.$notify({
            title: "Error",
            message:
              "Se ha producido un error al obtener el listado de archivos",
            type: "error",
            duration: 4000
          });
        });
    },

    /* Abre el modal de actualizar un archivo */
    openUpdateFileModal(helpFileRowData) {
      this.updateFileForm.id = helpFileRowData.id;
      this.updateFileForm.name = helpFileRowData.name;
      this.file = null;
      this.showUpdateFileModal = true;
    },

    /* Cierra el modal de actualización de un archivo */
    closeUpdateFileModal() {
      this.showUpdateFileModal = false;
      this.updateFileForm.id = 0;
      this.updateFileForm.name = "";
      this.file = null;
    },

    /* Actualiza el nombre de un archivo ya existente */
    updateFile(helpFileRowData) {
      this.$refs["updateFileForm"].validate(valid => {
        if (valid) {
          const updateForm = new FormData();
          updateForm.set("name", this.updateFileForm.name);
          updateForm.set("file", this.file);
          const header = { "Content-Type": "multipart/form-data" };

          FilesService.updateHelpFile(
            this.updateFileForm.id,
            updateForm,
            header
          )
            .then(response => {
              this.$notify({
                title: "Confirmación",
                message: "Archivo modificado correctamente",
                type: "success",
                duration: 3000
              });
              this.getFiles();
              this.closeUpdateFileModal();
            })
            .catch(() => {
              this.$notify({
                title: "Error",
                message: "Error al modificar el nombre",
                type: "error",
                duration: 3000
              });
            });
        } else {
          return false;
        }
      });
    },

    /* Elimina un archivo */
    deleteFile(id) {
      FilesService.deleteHelpFile(id)
        .then(response => {
          this.page = 1;
          this.getFiles();
          this.$notify({
            title: "Confirmación",
            message: "Archivo eliminado correctamente",
            type: "success",
            duration: 3000
          });
        })
        .catch(() => {
          this.$notify({
            title: "Error",
            message: "Error al eliminar el archivo",
            type: "error",
            duration: 3000
          });
        });
    },

    /* Abre el modal de nuevo archivo */
    openNewFileModal() {
      this.showNewFileModal = true;
    },

    /* Cierra el modal de nuevo archivo */
    closeNewFileModal() {
      this.newFileForm.name = "";
      this.file = null;
      this.showNewFileModal = false;
    },

    /* Sube un nuevo archivo */
    uploadNewFile() {
      this.$refs["newFileForm"].validate(valid => {
        if (valid) {
          const form = new FormData();
          form.set("name", this.newFileForm.name);
          form.set("file", this.file);
          const header = { "Content-Type": "multipart/form-data" };

          FilesService.saveHelpFile(form, header)
            .then(response => {
              this.$notify({
                title: "Confirmación",
                message: "Archivo subido correctamente",
                type: "success",
                duration: 3000
              });
              this.getFiles();
              this.closeNewFileModal();
            })
            .catch(() => {
              this.$notify({
                title: "Error",
                message: "Error al subir el archivo",
                type: "error",
                duration: 3000
              });
            });
        } else {
          return false;
        }
      });
    },

    /* Maneja el archivo seleccionado para subir */
    handleFileUpload(event, updateFile = false) {
      this.file = null;
      const fileTypes = ["pdf"]; // Extensiónes permitidas
      const newFile = !updateFile
        ? this.$refs.file.files[0]
        : this.$refs.updateFile.files[0];
      const extension = newFile.name
          .split(".")
          .pop()
          .toLowerCase(),
        isSuccess = fileTypes.indexOf(extension) > -1;
      if (newFile) {
        // && newFile.size < 2097152) {
        if (isSuccess) {
          const reader = new FileReader();
          reader.readAsBinaryString(newFile);
          /*reader.onloadstart = () => {
            this.file = 'loadStart';
          };*/
          reader.onload = () => {
            this.file = newFile;
          };
          reader.onerror = () => {
            this.file = null;
            this.$notify({
              title: "Error",
              message: "Error al cargar el archivo",
              type: "error",
              duration: 3000
            });
          };
        } else {
          this.$notify({
            title: "Error",
            message: "Este formato no está permitido (no es PDF)",
            type: "error",
            duration: 5000
          });
          this.file = null;
        }
      } /* else {
        this.$notify({title: "Error", message: "Tamaño maximo permitido 2 MG", type: "error", duration: 3000 });
        this.file = null;
      }*/
    }
  }
};
</script>

<style lang="scss">
@import "src/assets/sass/styles";
#files {
  width: 100%;
  height: auto;

  .filters {
    .el-select {
      width: 100%;
    }
  }
  .el-table {
    font-size: 20px;
    .el-table__header {
      th {
        background: $grey-white-color;
      }
    }
    td {
      padding: 25px 0px;
    }
    .cell {
      color: black;
      font-weight: 600;
    }
    img {
      width: 25px;
    }
  }
  .pag {
    margin: 0px;
    div.item {
      padding: 15px 0px;
      border-top: 1px solid $grey-dark-color;
      border-bottom: 1px solid $grey-dark-color;
      overflow: hidden;
      div {
        height: 100%;
        i {
          color: $grey-dark-color;
          font-size: 24px;
          font-weight: 600;
        }
        span {
          padding: 0px 10px;
        }
        .btn-prev,
        .btn-next {
          display: none;
        }
      }
    }
  }
}

.modal-new-file .input-name {
  border-radius: 50% !important;
}

.modal-new-file .input-file {
  width: 100%;
  color: white;
}

.modal-new-file .el-input.is-disabled .el-input__inner {
  background-color: #c0c4cc !important;
}

.modal-new-file .el-form-item__error {
  color: white !important;
}

@media (max-width: 992px) {
  #files {
    .el-table {
      font-size: 20px;
    }
  }
}

@media (max-width: 800px) {
  #files {
    .btn_secondary {
      width: 100% !important;
    }
  }
}

@media (max-width: 767px) {
  #files {
    .pag {
      div.item {
        &.arrows {
          display: none;
        }
        button {
          i {
            display: inline !important;
          }
        }
        .btn-prev,
        .btn-next {
          display: inline !important;
          color: $grey-dark-color !important;
        }
      }
    }
    .filters {
      .btn {
        margin-top: 20px !important;
      }
    }
  }
}
</style>
